import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    branch_id: "", // { label: "All", value: "" }
    consignor_id: "", // { label: "All", value: "" }
    from_location: "", // { label: "All", value: "" }
    to_location: "", // { label: "All", value: "" }
    lr_status: 0, // { label: "All", value: 0 }
    pod_status: 0,
    eway_bill_status: 0,
    search: "",
    start_date: "",
    end_date: "",
    offset: 1,
    // lr_pagination: 1,
  },
};

const ewayBillFilterSlice = createSlice({
  name: "input",
  initialState,
  reducers: {
    updateEwayBillFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
});

export const { updateEwayBillFilters } = ewayBillFilterSlice.actions;
export default ewayBillFilterSlice.reducer;
